import { createFileRoute } from '@tanstack/react-router'
import { AgentDetail } from '@/features/agents/components/agent-detail'

export const Route = createFileRoute('/_authenticated/agents/$agentId/')({
  component: AgentDetail,
})
